import { Link } from 'react-router-dom';

export default function CTA() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="bg-gradient-to-br from-primary-500 to-primary-700 rounded-3xl overflow-hidden shadow-2xl">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="p-12 lg:p-16 flex flex-col justify-center">
              <h2 className="text-4xl font-bold text-white mb-6">
                Comienza Tu Carrera Profesional Hoy
              </h2>
              <p className="text-xl text-blue-50 mb-8 leading-relaxed">
                Únete a nuestra comunidad de profesionales del adiestramiento canino. Obtén tu certificación oficial y transforma tu pasión en una carrera exitosa con metodología probada y reconocimiento europeo.
              </p>
              <ul className="space-y-4 mb-8">
                <li className="flex items-center gap-3 text-white">
                  <div className="w-6 h-6 bg-secondary-500/30 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-sm"></i>
                  </div>
                  <span>Acceso inmediato a todo el contenido formativo</span>
                </li>
                <li className="flex items-center gap-3 text-white">
                  <div className="w-6 h-6 bg-secondary-500/30 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-sm"></i>
                  </div>
                  <span>Certificación oficial reconocida en toda Europa</span>
                </li>
                <li className="flex items-center gap-3 text-white">
                  <div className="w-6 h-6 bg-secondary-500/30 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-sm"></i>
                  </div>
                  <span>Soporte personalizado de tutores expertos</span>
                </li>
                <li className="flex items-center gap-3 text-white">
                  <div className="w-6 h-6 bg-secondary-500/30 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-sm"></i>
                  </div>
                  <span>Comunidad activa de profesionales del sector</span>
                </li>
              </ul>
              <div className="flex flex-col sm:flex-row gap-4">
                <Link
                  to="/cursos"
                  className="inline-flex items-center justify-center rounded-full bg-accent-500 px-8 py-4 text-base font-semibold text-white shadow-lg hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
                >
                  Inscríbete Ahora
                  <i className="ri-arrow-right-line ml-2 text-xl"></i>
                </Link>
                <Link
                  to="/contacto"
                  className="inline-flex items-center justify-center rounded-full border-2 border-white px-8 py-4 text-base font-semibold text-white hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer"
                >
                  Solicitar Información
                </Link>
              </div>
            </div>
            <div 
              className="relative min-h-[400px] lg:min-h-full bg-cover bg-center"
              style={{
                backgroundImage: `url('https://static.readdy.ai/image/1641cce445e23a33732a9af05560332a/8b107b3bede808ad5aa24ee4ef378a77.jpeg')`
              }}
            >
              <div className="absolute inset-0 bg-gradient-to-r from-primary-600/50 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
